export const userRoles = {
  SUPER_ADMIN: "SuperAdmin",
  CLIENT_ADMIN: "ClientAdmin",
  CSR_USER: "CSR",
  SUPER_CSR_ADMIN: "SuperCSRAdmin",
};

/**
 * Internal roles eligible to be assigned as a company's tester. Shared by the
 * tester dropdown's user query and the server-side assignment validation so the
 * two can't drift.
 */
export const TESTER_ELIGIBLE_ROLES = [
  userRoles.SUPER_ADMIN,
  userRoles.SUPER_CSR_ADMIN,
] as const;

export function convertDollarsToCents(amount: number | undefined): number {
  return amount ? Math.round(amount * 100) : 0;
}

// A phone that can key a customer. Yelp forms hold "" until opt-in and some
// legacy form records hold "+", so neither may group records together.
export function hasRealPhone(phone?: string | null): boolean {
  return Boolean(phone) && phone !== "+";
}

export function normalizePhone(phone?: string | number) {
  if (!phone) {
    console.log(`[NORMALIZE_PHONE] No phone provided, returning empty string`);
    return "";
  }

  const phoneStr = phone.toString().trim();
  console.log(`[NORMALIZE_PHONE] Normalizing phone: ${phoneStr}`);

  // Remove all non-digit characters
  const digitsOnly = phoneStr.replace(/\D/g, "");

  // Handle various formats
  if (digitsOnly.length === 0) return "";

  // If it's 11 digits and starts with 1, remove the 1
  if (digitsOnly.length === 11 && digitsOnly.startsWith("1")) {
    return digitsOnly.slice(1);
  }

  // If it's 10 digits, return as is
  if (digitsOnly.length === 10) {
    console.log(`[NORMALIZE_PHONE] ✅ Normalized to 10-digit format: ${digitsOnly}`);
    return digitsOnly;
  }

  // If it's less than 10 digits, pad with zeros (for very short numbers)
  if (digitsOnly.length < 10) {
    const padded = digitsOnly.padStart(10, "0");
    console.log(`[NORMALIZE_PHONE] ⚠️ Padded from ${digitsOnly.length} to 10 digits: ${padded}`);
    return padded;
  }

  // If it's more than 10 digits, take the last 10
  if (digitsOnly.length > 10) {
    const trimmed = digitsOnly.slice(-10);
    console.log(`[NORMALIZE_PHONE] ⚠️ Trimmed from ${digitsOnly.length} to 10 digits: ${trimmed}`);
    return trimmed;
  }

  console.log(`[NORMALIZE_PHONE] ✅ Final normalized phone: ${digitsOnly}`);
  return digitsOnly;
}

export const normalizeTags = (str: string) =>
  str
    .toLowerCase()
    .replace(/[\s-]+/g, " ")
    .trim();
